import ObjectSolverService, { ObjectTypes } from '../../js/services/ObjectSolverService.js';

const objectSolver = new ObjectSolverService();

const { DRAGHANDLE_POLYGON_TYPE } = ObjectTypes;

/**
 * @params {any} object
 * @params {boolean|null} fallback
 * @return {boolean|null}
 */
export function isObjectMoveable( object, fallback = null ) {

	let value = null;

	if (object) try {

		let type = objectSolver.solveObjectType( object );

		console.debug( "isObjectMoveable", object, type );

		switch (type) {
			default:
				break;
		}

		if (object.userData && object.userData.hasOwnProperty("moveable")) {
			value = object.userData["moveable"] ? true : false;
		}

		if (value == null) {
			switch (type) {
				case DRAGHANDLE_POLYGON_TYPE:
					value = true;
					break;
			}
		}

	} catch (error) {
		console.warn( error );
	}

	if (value == null) return fallback;

	return value;
}

/**
 * @params {any} object
 * @params {boolean} value
 * @return {void}
 */
export function setIsObjectMoveable( object, value ) {
	let type = objectSolver.solveObjectType( object );

	try {
		switch (type) {
			case DRAGHANDLE_POLYGON_TYPE:
				object.userData["moveable"] = value;
				break;
		}
	} catch (error) {
		console.warn( error );
	}
}



window.setIsObjectMoveable = setIsObjectMoveable;
window.isObjectMoveable = isObjectMoveable;
